module.exports = __webpack_public_path__ + "img/8f592cbf1f65bb7de963f4615ba3a96b.e00346ba.png";